import React, { useState, useEffect, useContext } from 'react';
import { WebsiteFileContext } from "../../context/WebsiteFileProvider";

const DocuSignStatusBar = ({ fileId }) => {
  const { getDocuSignStatus } = useContext(WebsiteFileContext);
  const [docuSignStatus, setDocuSignStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocuSignStatus = async () => {
      if (!fileId) return;
      setLoading(true);
      setError(null);

      try {
        const status = await getDocuSignStatus(fileId);
        if (status) {
          setDocuSignStatus(status.map((s, index, array) => ({
            ...s,
            formattedDate: formatDate(s.date),
            description: formatDescription(s, index, array.length)
          })));
        } else {
          setError("No status data returned");
        }
      } catch (error) {
        console.error('Error fetching DocuSign status:', error);
        setError('Failed to fetch status');
      } finally {
        setLoading(false);
      }
    };
    fetchDocuSignStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId, getDocuSignStatus]);

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime()) && parsedDate.getFullYear() > 1970) {
      return parsedDate.toLocaleDateString('default', {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    }
    return "";
  };

  const formatDescription = (status, index, total) => {
    const formattedDateTime = formatDate(status.date);
    if (index === 0 || index === total - 1) {
      return `${status.description} ${formattedDateTime}`;
    } else {
      const metaData = status.metadata;
      let message = `Waiting on ${metaData.name}`;
      message += ` - ${metaData.status.charAt(0).toUpperCase() + metaData.status.slice(1)}.`;
      message += ` Document was ${metaData.status === 'sent' ? 'delivered' : 'created'} to ${metaData.email}`;
      message += status.completed ? ` (Completed) ${formattedDateTime}` : ' (Pending)';
      return message;
    }
  };

  const allCompleted = docuSignStatus.every(status => status.completed);

  return (
    <div className="docusign-status-bar relative">
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        <ul className="flex w-full rounded overflow-visible">
          {docuSignStatus.map((status, index) => (
            <li key={index}
                className={`flex-1 text-white text-xs font-bold py-1 px-4 text-center ml-1 rounded-sm transition-transform duration-300 ease-in-out cursor-pointer
                            ${allCompleted ? 'bg-green-500' : status.completed ? 'bg-blue-500 dark:bg-indigo-500' : 'bg-gray-300'}
                            hover:scale-110 hover:py-1.5 relative group`}>
            <span
              className="tooltip-content absolute top-4 left-1/2 -translate-x-3/4 text-white py-2 px-2 rounded-lg shadow-lg opacity-30 group-hover:opacity-100 transition-opacity duration-300 ease-in-out z-50"
              dangerouslySetInnerHTML={{__html: status.description}}
            />

            </li>
          ))}
        </ul>
      )}
      {!docuSignStatus.length && <p>No status updates available.</p>}
    </div>
  );
};

export default DocuSignStatusBar;
